import React, { useEffect, useState } from 'react';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Breadcrumbs from '../../components/BreadCrumbs';
import Table from '../../components/tables/Table';
import Pagination from '../../components/tables/pagination/Pagination';
import { getBulkEnquiries, patchBulkEnquiry } from '../../services/enquiries';
import { toast } from 'react-toastify';
import CustomLoading from '../../components/customLoading/CustomLoading';
import { formatDateTime } from '../../utils/FormatDateTime';
import Dropdown from '../../components/inputFields/DropDown';
import ShowModal from '../../utils/ShowModal';
import AddBulkOrderNote from './AddBulkOrderNote';
import { getUserRole } from '../../helpers/local_storage_helpers';
import { BiNotepad } from 'react-icons/bi';

const BulkEnquiries = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const headers = [
        { label: "S. No.", key: "sno" },
        { label: "Created At", key: "created_at" },
        getUserRole() === "admin" ? { label: "Att. By", key: "attended_by" } : {},
        { label: "Shop", key: "shop_name" },
        { label: "User", key: "user_name" },
        { label: "Phone", key: "user_phone_number" },
        { label: "Product", key: "product_name" },
        { label: "Quantity", key: "quantity" },
        { label: "Exp. Deliv.", key: "expected_delivery_date" },
        { label: "Status", key: "status" },
        { label: "Note", key: "note" },
    ];

    const pageSize = 50;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getBulkEnquiries(query);
            if (res.status === 200) {
                const data = res.data;
                setData(data)
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData("");
    }, []);

    const handleRowStatusChange = async (item, value) => {
        try {
            const data = {
                status: value,
            };
            let res = await patchBulkEnquiry({
                data: data,
                id: item.id,
            });
            if (res.status === 200) {
                toast.success("Status Updated");
                fetchData(``);
            } else {
                toast.error("Unable to Update Status");
            }
        } catch (error) {
            console.error("Error in Orders:", error);
        }
    };
    const [modalIsOpen, setIsOpen] = useState(false);
    const [openingItem, setOpeningItem] = useState({});

    // Open modal with the selected PDF ID
    const openModal = (item) => {
        setOpeningItem(item);
        setIsOpen(true);
    };

    // Close modal
    const closeModal = () => {
        setIsOpen(false);
        setOpeningItem({});
    };

    const onSave = () => {
        fetchData();
        closeModal();
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Enquiries' },
            { name: "Bulk Enquiries" },
        ]} />
        <div className="py-2">
            <StyledHeadingText text={"Bulk Enquiries"} />
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={data?.results?.map((item, index) => (
                            {
                                sno: <p className={`rounded-full text-center font-bold text-white ${item.note && item.note.length !== 0 ? "bg-primary" : "bg-red-700"}`} > {index + 1}</p>,
                                attended_by: <p className='max-w-24 truncate'>{item.attended_by}</p>,
                                shop_name: <p>{item.shop_name}</p>,
                                user_name: <p>{item.user_name}</p>,
                                user_phone_number: <p>{item.user_phone_number}</p>,
                                product_name: <p className='max-w-[20rem] truncate' title={item.product_name}>{item.product_name}</p>,
                                quantity: <p>{item.quantity}</p>,
                                expected_delivery_date: <p>{item.expected_delivery_date}</p>,
                                status: <Dropdown
                                    name="status"
                                    options={[
                                        { label: "Pending", value: "Pending" },
                                        { label: "Accepted", value: "Accepted" },
                                        { label: "Rejected", value: "Rejected" },
                                    ]}
                                    placeholder={item.status}
                                    onChange={(value) => handleRowStatusChange(item, value)}
                                />,
                                created_at: <p>{formatDateTime(item.created_at)}</p>,
                                note: <BiNotepad size={24} color='green' onClick={() => openModal(item)} className='cursor-pointer' />,
                            }))}
                    />
                </div >}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            data.count !== 0 ?
                <Pagination
                    currentPage={currentPage}
                    
                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setData}
                /> : <></>
        }
        <ShowModal contentLabel={"Note alert"} isOpen={modalIsOpen} modalWidth="50%" isSidebar={true} onRequestClose={closeModal} componentToPass={<AddBulkOrderNote item={openingItem} onSave={onSave} />} />
    </>
    );
};
export default BulkEnquiries;